import React from "react";
import { Grid, GridRow, GridColumn, ScrollNavigationProvider, Stack, ScrollNavigationSection } from "sprint-common-web";

import { AirlinesDataProvider } from "../../../common/data/lookup-data-providers/AirlinesDataProvider";
import { LanguagesDataProvider } from "../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { ciRoutes } from "../../ContentIngestionRoutes";
import { FileRecordDetailsStateProvider } from "../../file-records/details/hooks/FileRecordDetailsStateProvider";
import { CloudFileQcDoneButton } from "./buttons/CloudFileQcDoneButton";
import { RejectCloudFileButton } from "./buttons/RejectCloudFileButton";
import { RequestCloudFileFixButton } from "./buttons/RequestCloudFileFixButton";
import { CloudFileDashboardProvider } from "./common/context/CloudFileDashboardProvider";
import { FileRecordLookupButton } from "./file-record-lookup/FileRecordLookupButton";
import {
    CloudFileDetailsDashboardNavigation,
    InfoNavigationItem,
    PreviewNavigationItem,
    TechnicalNavigationItem
} from "./navigation/CloudFileDetailsDashboardNavigation";
import { CloudFileRequestWaitingForClientResponseButton } from "./request-waiting-for-client-response/CloudFileRequestWaitingForClientResponseButton";
import { CloudFileAssociateSection } from "./sections/associate/CloudFileAssociateSection";
import { CloudFileAssociationContextProvider } from "./sections/associate/context/CloudFileAssociationContextProvider";
import { FileRecordDetailsSection } from "./sections/file-record-details/FileRecordDetailsSection";
import { CloudFileInfoSection } from "./sections/info/CloudFileInfoSection";
import { CloudFilePreviewProvider } from "./sections/preview/cloud-file-preview/context/CloudFilePreviewProvider";
import { CloudFilePreviewSection } from "./sections/preview/CloudFilePreviewSection";
import { CloudFileTechnicalSection } from "./sections/technical/CloudFileTechnicalSection";
import { CloudFileWarningSection } from "./sections/warning/CloudFileWarningSection";
import { CloudFileInQcDoneWarning } from "./warning/CloudFileInQcDoneWarning";

export const CloudFileDetailsDashboard = (): JSX.Element => {
    return (
        <CloudFileDashboardProvider>
            <LanguagesDataProvider>
                <AirlinesDataProvider>
                    <ScrollNavigationProvider>
                        <PageHeader>
                            <Stack style={{ flex: 1 }}>
                                <HeaderBreadcrumb routes={ciRoutes} />
                            </Stack>
                            <CloudFileQcDoneButton key="cloud-file-qc-done" />
                            <FileRecordLookupButton key="file-record-lookup" />
                            <CloudFileRequestWaitingForClientResponseButton key="request-waiting-for-client-response" />
                            <RejectCloudFileButton key="reject-cloud-file" />
                            <RequestCloudFileFixButton key="request-cloud-file-fix" />
                        </PageHeader>
                        <CloudFileDetailsDashboardNavigation />
                        <CloudFileInQcDoneWarning />
                        <Grid>
                            <GridRow>
                                <GridColumn>
                                    <CloudFileWarningSection />
                                </GridColumn>
                            </GridRow>
                            <ScrollNavigationSection id={InfoNavigationItem.id}>
                                <GridRow>
                                    <GridColumn sm={6}>
                                        <CloudFileInfoSection minHeight={500} />
                                    </GridColumn>
                                    <GridColumn sm={6}>
                                        <CloudFileAssociationContextProvider>
                                            <CloudFileAssociateSection minHeight={500} />
                                        </CloudFileAssociationContextProvider>
                                    </GridColumn>
                                </GridRow>
                            </ScrollNavigationSection>
                            <ScrollNavigationSection id={TechnicalNavigationItem.id}>
                                <GridRow>
                                    <GridColumn>
                                        <CloudFileTechnicalSection />
                                    </GridColumn>
                                </GridRow>
                            </ScrollNavigationSection>
                            <ScrollNavigationSection id={PreviewNavigationItem.id}>
                                <GridRow>
                                    <GridColumn sm={12}>
                                        <CloudFilePreviewProvider>
                                            <CloudFilePreviewSection minHeight={520} />
                                        </CloudFilePreviewProvider>
                                    </GridColumn>
                                </GridRow>
                            </ScrollNavigationSection>
                            <GridRow>
                                <GridColumn>
                                    <FileRecordDetailsStateProvider>
                                        <FileRecordDetailsSection />
                                    </FileRecordDetailsStateProvider>
                                </GridColumn>
                            </GridRow>
                        </Grid>
                    </ScrollNavigationProvider>
                </AirlinesDataProvider>
            </LanguagesDataProvider>
        </CloudFileDashboardProvider>
    );
};
